import { Button, message } from "antd";
import { useEffect, useState } from "react";
import StepCard from "../ui/StepCard";
import { Card, ListItem } from "./SectionTwo.default";
import CompletedStageCard from "../ui/CompletedStageCard";

const awarnessStageStepCards: Card[] = [
  {
    count: 1,
    status: "completed",
    title: "Establish your well-being committee",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Assign members to the Well-Being Committee, ensuring representation
          from leadership, HR, and employees.
        </li>
        <li>
          The Well-Being Committee is responsible for overseeing initiatives,
          reviewing policies, and driving workplace well-being programs.
        </li>
        <li>
          Hover over each checklist item to view additional details and examples
          (e.g., what constitutes high absenteeism or poor employee engagement).
        </li>
        <li>
          Select members from all departments to ensure diverse perspectives and
          assign them different categories (e.g., Mental Health, Fitness,
          Educational).
        </li>
        <li>Click Save Selections to finalize your committee</li>
        <li>
          You may not edit your committee members. If you wish to make changes,
          please start a new form by clicking "START".
        </li>
      </>
    ),
    backgroundColor: "#d17f42",
    actions: [
      {
        name: "assign",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
  {
    count: 2,
    status: "completed",
    title: "formulate the well-being policy",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Develop or refine your organization’s well-being policy. This policy
          outlines your organization’s commitment to creating a healthy,
          supportive work environment.
        </li>
        <li>
          Use the provided template or upload your existing policy for review.
        </li>
        <li>
          Add areas:
          <br /> -Vision and values of the organization
          <ol>
            <li>mission and strategic directions </li>
            <li> company challenge and causation of problems</li>
            <li>
              The long and short-term goals of the companyand how the program
              can assist in meeting them.
            </li>
            <li>
              How NUVO WELL's involvement will be of added value for the company
            </li>
          </ol>
        </li>
        <li>Click Save Selections to store your responses</li>
        <li>
          You may not edit your submitted policy. If changes are required,
          please start a new draft by clicking "START".
        </li>
      </>
    ),
    backgroundColor: "#8eb1bd",
    actions: [
      {
        name: "start",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
  {
    count: 3,
    status: "completed",
    title: "Communicate the policy statement",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Share the finalized policy statement with employees across the
          organization.
        </li>
        <li>
          Use the communication tools provided to send the statement via email,
          the internal portal, or department announcements.
        </li>
        <li>
          Ensure that employees acknowledge receipt of the policy to track
          awareness and compliance by checking your Analytics - Policy and
          Process Effectiveness page.
        </li>
        <li>Click Send Policy to distribute your communication.</li>
        <li>
          Once the policy is sent, you may not edit it. If you need to make
          updates, please create a new communication by clicking "START".
        </li>
      </>
    ),
    backgroundColor: "#bdb0ac",
    actions: [
      {
        name: "Send",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
];

const completedStageList: ListItem[] = [
  {
    name: "Review Your Inputs:",
    items: [
      "Visit the summary page to review all selected issues.",
      "Click Edit to make any necessary changes.",
    ],
  },
  {
    name: "Submit the Policy & Commitment:",
    items: [
      "Once you’re satisfied with your inputs, click the Submit Policy & Commitment Stage button.",
      "A confirmation popup will appear. Confirm to lock your inputs and generate a final report.",
    ],
  },
  {
    name: "Post-Submission Access:",
    items: [
      "After submission, this stage will be locked for edits but will remain accessible for viewing and exporting reports.",
      "If you need to make changes after submission, contact your platform administrator to reopen the stage.",
    ],
  },
  {
    name: "Move to the Next Stage:",
    items: [
      "Upon submission, you’ll be automatically redirected to the Overview page so you may continue with stage III  Planning & Actions Stage.",
      "Refer back to this stage anytime by clicking on the Policy & Commitment  Stage tab in the Overview",
    ],
  },
];

const completedStageTitle = "Completing the Policy & Commitment Stage";

const subTitleText = (
  <p>
    Congratulations on completing Policy & Commitment! Follow these steps to
    finalize this stage:
  </p>
);

function SectionTwo() {
  const [submitActive, setSubmitActive] = useState(false);
  const [showCompletedStage, setShowCompletedStage] = useState(false);

  //Lifecycle
  useEffect(() => {
    findUncompletedSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Events
  function onSubmit() {
    setShowCompletedStage(true);
  }

  // Methods
  function findUncompletedSteps() {
    const uncompletedSteps = awarnessStageStepCards.filter(
      (step) => step.status !== "completed",
    );

    if (uncompletedSteps.length) {
      setSubmitActive(false);
    } else {
      setSubmitActive(true);
    }

    return uncompletedSteps;
  }

  return (
    <section className="mx-auto max-w-[1920px] px-16 py-16">
      {/* Step Cards */}
      {awarnessStageStepCards.map((card) => {
        return (
          <StepCard
            key={card.count}
            countValue={card.count}
            status={card.status}
            title={card.title}
            checkListTitle={card.listTitle}
            checkList={card.checkList}
            backgroundColor={card.backgroundColor}
            actions={card.actions}
          />
        );
      })}
      {/* Submit Button */}
      <div className="flex justify-center py-8">
        <Button
          disabled={!submitActive}
          className={`bg-[#ffc107] px-16 py-8 text-lg font-bold tracking-wide ${submitActive && "hover:text-white"} `}
          onClick={onSubmit}
        >
          SUBMIT
        </Button>
      </div>
      {/* Completed Stage Component That Shows On Submmit */}
      {(showCompletedStage || submitActive) && (
        <CompletedStageCard
          title={completedStageTitle}
          subTitleText={subTitleText}
          list={completedStageList}
        />
      )}
    </section>
  );
}

export default SectionTwo;
